import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  inputClasses,
  inputLabelClasses,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import Home from "../home/Home";
import FundRqst_service from "../../Services/FundRqst_service";
import Snackbar from "../Snacbar";
import { getUserId } from "../Utils/Common";
import { saveAs } from "file-saver";
import FileSaver from "file-saver";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { ToggleButton } from "@mui/material";

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
  },
});
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item1 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));
const Item2 = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "right",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: "1px solid black",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    backgroundColor: "rgb(61, 195, 177)",
    padding: theme.spacing(0.5),
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
}));

function FundRelease() {
  // BE NO
  const [BeNoHidden, setBeNoHidden] = useState(true);
  const [BeNoSearchHidden, setBeNoSearchHidden] = useState(true);
  const [beNoValue, setBeNoValue] = useState("");
  const [searchPros, setsearchPros] = useState(false);

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [status, setstatus] = useState("");
  const [fundstatusdrp, setfundstatusdrp] = useState([]);
  const [Vendordrp, setVendordrp] = useState([]);
  const [PaymentModedrp, setPaymentModedrp] = useState([]);
  const [voucherdrp, setvoucherdrp] = useState([]);
  const [printeddrp, setprinteddrp] = useState([]);

  const [fundreleasevalues, setfundreleasevalues] = useState({
    cmid: "",
    purpose_pmtid: "",
    purpose_reqpurid: "",
    purposeSummary_id: "",

    Blnc_amt: "",
    Reqamt: "",
    Aprvlamt: "",
    FirstLvlamt: "",
    secLvlamt: "",
    allocatedamt: "",

    fundstatus: "",
    jobNo: "",
    vendorType: "",
    miscellaneousType: "",
    clientType: "",
    Release_amt: "",
    Allocated_PyMd: "",
    Voucher_no: "",
    Voucher_type: "",
    printedType: "",
    releaseRemarks: "",
    transactionRefInfo: "",
    BankName: "",
    Account_No: "",
    ifscode: "",
    Beneficary_Name: "",
    gstin_No: "",
  });

  ///Handle Change=>>
  const FundReleaseStatusHandleChange = (e) => {
    const value = e.target.value;

    // reset data
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setReleaseDetails([]);
    setReleaseDetails2([]);
    setReleaseDetails3([]);
    setReleaseDetails4([]);
    setReleaseDetails5([]);

    setfundreleasevalues({
      ...fundreleasevalues,
      fundstatus: value,
      cmid: "",
      purpose_pmtid: "",
      Allocated_PyMd: "",
      purpose_reqpurid: "",
      purposeSummary_id: "",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Release_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Blnc_amt: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      jobNo: "",
    });

    // hide BE NO by default
    setBeNoHidden(true);
    setBeNoSearchHidden(true);

    // ✅ BE NO case
    if (value === "BE NO") {
      setBeNoHidden(false);
      setBeNoSearchHidden(false);
      SetVendorHidden(true);
      SetJobHidden(true);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(true);
      return; // stop here
    }

    // Normal logic (unchanged)
    if (value === "JOB") setstatus(1);
    else if (value === "VENDOR") setstatus(2);
    else if (value === "MISCELLANEOUS") setstatus(3);
    else if (value === "CLIENT") setstatus(4);

    let consignmentNumber = "-1";
    if (value === "JOB") {
      consignmentNumber = fundreleasevalues.jobNo || "-1";
    } else {
      consignmentNumber = fundreleasevalues.vendorType || "-1";
    }

    const details = { consignmentNumber, status: "6", requestStatus: value };

    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setReleaseDetails(res.data);
      setFilteredDetails(res.data);
    });

    FundRqst_service.getPaymentJobNo(details).then((res) => {
      setReleaseDetails4(res.data);
      setFilteredDetails2(res.data);
    });

    FundRqst_service.getBillPaymentType().then((res) =>
      setPaymentModedrp(res.data)
    );
    FundRqst_service.getVoucherType().then((res) => setvoucherdrp(res.data));
    FundRqst_service.getPrintedType().then((res) => setprinteddrp(res.data));

    if (value === "JOB") {
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);
    } else if (["VENDOR", "MISCELLANEOUS", "CLIENT"].includes(value)) {
      FundRqst_service.getVendorType(value).then((res) =>
        setVendordrp(res.data)
      );
      SetVendorHidden(false);
      SetJobHidden(true);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(true);
    } else if (value === "") {
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(true);
      settablehidden(true);
      setsearchbtnhidden(false);
    }
  };
  const handleBeNoSearch = async () => {
    const beNo = beNoValue && beNoValue.trim();
    if (!beNo) {
      setMessage("Please enter BE No before searching!");
      setseverit("warning");
      setOpen(true);
      return;
    }

    setsearchPros(true);
    try {
      // 1️⃣ get BE NO data
      const beNoPayload = {
        consignmentNumber: beNo,
        status: "6",
        requestStatus: "BE NO",
      };
      const [nonJobRes, jobRes] = await Promise.all([
        FundRqst_service.getPaymentNonJobNo(beNoPayload),
        FundRqst_service.getPaymentJobNo(beNoPayload),
      ]);
      const beNoData = [...(nonJobRes?.data || []), ...(jobRes?.data || [])];
      const consignmentNumbers = [
        ...new Set(beNoData.map((d) => d.consignmentNumber).filter(Boolean)),
      ];

      if (consignmentNumbers.length === 0) {
        setMessage("No consignment numbers found for this BE No!");
        setseverit("info");
        setOpen(true);
        setsearchPros(false);
        return;
      }

      // 2️⃣ fetch JOB data for those consignment numbers
      const jobRequests = consignmentNumbers.map((cno) => {
        const jobPayload = {
          consignmentNumber: cno,
          status: "6",
          requestStatus: "JOB",
        };
        return Promise.all([
          FundRqst_service.getPaymentNonJobNo(jobPayload),
          FundRqst_service.getPaymentJobNo(jobPayload),
        ]);
      });
      const responses = await Promise.all(jobRequests);

      const allNonJob = [];
      const allJob = [];
      responses.forEach(([nonJob, job]) => {
        if (nonJob?.data) allNonJob.push(...nonJob.data);
        if (job?.data) allJob.push(...job.data);
      });

      // 3️⃣ update your release tables
      setReleaseDetails(allNonJob);
      setFilteredDetails(allNonJob);
      setReleaseDetails4(allJob);
      setFilteredDetails2(allJob);

      setBeNoHidden(true);
      setBeNoSearchHidden(true);
      SetVendorHidden(true);
      SetJobHidden(false);
      setdesignHidden(false);
      settablehidden(false);
      setsearchbtnhidden(false);

      // ✅ Update Fund Status dropdown value
      setfundreleasevalues((prev) => ({
        ...prev,
        fundstatus: "JOB",
      }));

      // ✅ Optional success feedback
      setMessage("BE No search completed — switched to JOB mode");
      setseverit("success");
      setOpen(true);
    } catch (err) {
      setMessage(err.message || "Error fetching BE NO details");
      setseverit("error");
      setOpen(true);
    } finally {
      setsearchPros(false);
    }
  };

  const FundRelease_jobNoHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const FundRelease_blncAmtHandleChange = (e) => {
    setfundreleasevalues({ ...fundreleasevalues, Blnc_amt: e.target.value });
  };
  const fundrelease_vendortypHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      vendorType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
    let details = {
      consignmentNumber: e.target.value,
      status: "6",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setReleaseDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: e.target.value,
      status: "6",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setReleaseDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };
  const fundrelease_alocatedamtHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Release_amt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_Allocated_PyMdHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Allocated_PyMd: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_Voucher_noHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Voucher_no: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_Voucher_typeHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Voucher_type: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_printedTypeHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      printedType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_releaseRemarksHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      releaseRemarks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_transactionRefInfoHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      transactionRefInfo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_BankNameHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      BankName: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_Account_NoHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Account_No: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_ifscodeHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      ifscode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_Beneficary_NameHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      Beneficary_Name: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fundrelease_gstin_NoHandleChange = (e) => {
    setfundreleasevalues({
      ...fundreleasevalues,
      gstin_No: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const FundStsName = () => {
    if (status === 1) {
      return "Job No";
    } else if (status === 2) {
      return "VENDOR";
    } else if (status === 3) {
      return "MISCELLANEOUS";
    } else if (status === 4) {
      return "CLIENT";
    }
  };
  //keydown
  const jobkeydown = (e) => {
    if (e.key === "Enter") {
      searchBtn();
    }
  };
  const releaseAmtKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("payid").focus();
    }
  };
  const paymentMdKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("voucherNo").focus();
    }
  };
  const voucherNoKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("Vchrid").focus();
    }
  };
  const vouchertypeKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("printid").focus();
    }
  };
  const printedKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("releaseRmks").focus();
    }
  };
  const releaseRmkskeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("TrnsRefNo").focus();
    }
  };
  const TrnsRefNoKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("banknameid").focus();
    }
  };
  const bankNameKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("AcntNo").focus();
    }
  };
  const AcntNoKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("ifscodeId").focus();
    }
  };
  const ifscodeKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("beneficaryId").focus();
    }
  };
  const beneficaryNameKeydown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("gstinId").focus();
    }
  };
  ///hidden
  const [designHidden, setdesignHidden] = useState(true);
  const [tablehidden, settablehidden] = useState(true);
  const [VendorHidden, SetVendorHidden] = useState(true);
  const [searchbtnhidden, setsearchbtnhidden] = useState(true);
  const [JobHidden, SetJobHidden] = useState(false);
  const [imgUpload, setimgUpload] = useState(false);
  const [ReleaseDetails, setReleaseDetails] = useState([]);
  const [ReleaseDetails2, setReleaseDetails2] = useState([]);
  const [ReleaseDetails3, setReleaseDetails3] = useState([]);
  const [ReleaseDetails4, setReleaseDetails4] = useState([]);
  const [ReleaseDetails5, setReleaseDetails5] = useState([]);
  // const [paymentcopydetails, setpaymentcopydetails] = useState([]);
  //
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [FilteredDetails2, setFilteredDetails2] = useState([]);

  const [ALLOCATEDbtn, setALLOCATEDbtn] = useState(true);
  const [UpdateBtn, setUpdateBtn] = useState(true);
  const [NonAlocatedBtn, setNonAlocatedBtn] = useState(true);
  const [Upload_Btn, setUpload_Btn] = useState(true);
  const [Download_Rcpt_Btn, setDownload_Rcpt_Btn] = useState(true);
  const [Download_Rqst_Btn, setDownload_Rqst_Btn] = useState(true);
  ///processing
  const [allocatedProcs, setallocatedProcs] = useState(false);
  const [updateProcs, setupdateProcs] = useState(false);
  const [nonallocatedProcs, setnonallocatedProcs] = useState(false);
  const [refreshProcs, setrefreshProcs] = useState(false);
  const [utrBulkProcs, setutrBulkProcs] = useState(false);
  const [uploadRecCopyProcs, setuploadRecCopyProcs] = useState(false);
  const [dwnldRcpCopyProcs, setdwnldRcpCopyProcs] = useState(false);
  const [dwnldRqstCopyProcs, setdwnldRqstCopyProcs] = useState(false);
  ///restalloperations
  const resetalloperation = () => {
    setfundreleasevalues({
      ...fundreleasevalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      Allocated_PyMd: "",
      purposeSummary_id: "",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Release_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Blnc_amt: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      jobNo: "",
    });
    setallocatedProcs(false);
    setupdateProcs(false);
    setnonallocatedProcs(false);
    setrefreshProcs(false);
    setutrBulkProcs(false);
    setuploadRecCopyProcs(false);
    setdwnldRcpCopyProcs(false);
    setdwnldRqstCopyProcs(false);
    setFilteredDetails([]);
    setFilteredDetails2([]);
    setReleaseDetails([]);
    setReleaseDetails2([]);
    setReleaseDetails3([]);
    setReleaseDetails4([]);
    setReleaseDetails5([]);
    setALLOCATEDbtn(true);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(true);
    setDownload_Rcpt_Btn(true);
    setDownload_Rqst_Btn(true);
    Getpaymentjob_nonjob_no();
  };
  /////
  const validationprocess = () => {
    if (fundreleasevalues.Release_amt !== "") {
      if (fundreleasevalues.Allocated_PyMd !== "") {
        if (fundreleasevalues.Voucher_type !== "") {
          if (fundreleasevalues.printedType !== "") {
            return true;
          } else {
            setMessage("Please Select Printed Type");
            setseverit("warning");
            setOpen(true);
            document.getElementById("printid").focus();
          }
        } else {
          setMessage("Please Select Voucher Type");
          setseverit("warning");
          setOpen(true);
          document.getElementById("Vchrid").focus();
        }
      } else {
        setMessage("Please Select Payment Mode");
        setseverit("warning");
        setOpen(true);
        document.getElementById("payid").focus();
      }
    } else {
      setMessage("Please Enter Payment Request Amount");
      setseverit("warning");
      setOpen(true);
      document.getElementById("releaseamt").focus();
    }
    return false;
  };

  //jobsearch=================>
  const searchBtn = () => {
    setALLOCATEDbtn(true);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(true);
    setDownload_Rcpt_Btn(true);
    setDownload_Rqst_Btn(true);
    setfundreleasevalues({
      ...fundreleasevalues,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Release_amt: "",
      Blnc_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      Allocated_PyMd: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
    });
    setReleaseDetails2([]);
    setReleaseDetails3([]);
    Getpaymentjob_nonjob_no();
  };
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState([]);
  ///table1click
  const getnonpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);
    setReleaseDetails2([]);
    setReleaseDetails5([]);
    setALLOCATEDbtn(true);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(true);
    setDownload_Rcpt_Btn(true);
    setDownload_Rqst_Btn(true);
    setfundreleasevalues({
      ...fundreleasevalues,
      cmid: trns.cmId,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Allocated_PyMd: "",
      Release_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      Blnc_amt: "",
    });
    setReleaseDetails3([]);
    let details = {
      cmId: trns.cmId,
      status: "11",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setReleaseDetails2(res.data);
    });

    let details2 = {
      paymentId: trns.cmId,
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setReleaseDetails5(res.data);
    });
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  ///table2click
  const nonverifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setReleaseDetails3([]);
    setALLOCATEDbtn(false);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(false);
    setDownload_Rcpt_Btn(false);
    setDownload_Rqst_Btn(false);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 1);

    // let details = { cmId: fundreleasevalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
    // FundRqst_service.getPaymentCopy(details).then(res => {
    //     setpaymentcopydetails(res.data);
    // })
  };
  const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ///table3click
  const verifypurpose = (trns) => {
    const selectedIndex = selected1.indexOf(trns.reqAmount);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected1, trns.reqAmount);
    }
    setSelected1(newSelected);
    setReleaseDetails2([]);
    setALLOCATEDbtn(true);
    setUpdateBtn(false);
    setNonAlocatedBtn(false);
    setUpload_Btn(false);
    setDownload_Rcpt_Btn(false);
    setDownload_Rqst_Btn(false);

    getpaymentdetailsAssign(trns.paymentId, trns.reqPurpose, 2);

    // let details = { cmId: fundreleasevalues.cmid, reqPurpose: trns.reqPurpose, status: '1' }
    // FundRqst_service.getPaymentCopy(details).then(res => {
    //     setpaymentcopydetails(res.data);
    // })
  };
  const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
  ///table4click
  const getpurpose = (trns) => {
    const selectedIndex = selected.indexOf(trns.consignmentNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = (selected, trns.consignmentNumber);
    }
    setSelected(newSelected);

    setReleaseDetails3([]);
    setReleaseDetails5([]);
    setALLOCATEDbtn(true);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(true);
    setDownload_Rcpt_Btn(true);
    setDownload_Rqst_Btn(true);
    setfundreleasevalues({
      ...fundreleasevalues,
      cmid: trns.cmId,
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Allocated_PyMd: "",
      Release_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      Blnc_amt: "",
    });
    setReleaseDetails2([]);
    let details = {
      cmId: trns.cmId,
      status: "12",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentReqPurpose(details).then((res) => {
      setReleaseDetails3(res.data);
    });

    let details2 = {
      paymentId: trns.cmId,
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentSummaryDetails(details2).then((res) => {
      setReleaseDetails5(res.data);
    });
  };
  const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
  ////get functions======>
  /////
  const Getpaymentjob_nonjob_no = () => {
    setReleaseDetails4([]);
    setFilteredDetails([]);
    setReleaseDetails([]);
    setFilteredDetails2([]);
    var consignmentNumber = "";
    if (fundreleasevalues.fundstatus === "JOB") {
      if (fundreleasevalues.jobNo === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = fundreleasevalues.jobNo;
      }
    } else if (fundreleasevalues.fundstatus !== "JOB") {
      if (fundreleasevalues.vendorType === "") {
        consignmentNumber = "-1";
      } else {
        consignmentNumber = fundreleasevalues.vendorType;
      }
    }
    let details = {
      consignmentNumber: consignmentNumber,
      status: "6",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentNonJobNo(details).then((res) => {
      setReleaseDetails(res.data);
      setFilteredDetails(res.data);
    });

    let details2 = {
      consignmentNumber: consignmentNumber,
      status: "6",
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.getPaymentJobNo(details2).then((res) => {
      setReleaseDetails4(res.data);
      setFilteredDetails2(res.data);
    });
  };

  ///assignFundRelease
  const getpaymentdetailsAssign = (payid, reqid, val) => {
    let details = { paymentId: payid };
    var balanceAmount = "";
    FundRqst_service.getPaymentDetails(details)
      .then((res) => {
        FundRqst_service.getBalancePayment(payid).then((trns) => {
          const amt = trns.data;
          const blncdetails = amt.map((trns) => trns);
          balanceAmount = blncdetails[0].balanceAmount;
        });
        const data = res.data;
        const details = data.map((trn) => trn);
        var txt_amount,
          allocatedMode = "",
          VoucherType = "",
          PrintedBy = "";
        if (val === 1) {
          txt_amount = details[0].releaseAmount;
        } else {
          txt_amount = details[0].allocatedAmount;
        }
        if (
          details[0].appMode === null ||
          details[0].appMode === "" ||
          !details[0].appMode
        ) {
          allocatedMode = "";
        } else {
          allocatedMode = details[0].appMode;
        }
        if (
          details[0].allocatedVoucherType === null ||
          details[0].allocatedVoucherType === "" ||
          !details[0].allocatedVoucherType
        ) {
          VoucherType = "";
        } else {
          VoucherType = details[0].allocatedVoucherType;
        }
        if (
          details[0].allocatedPrintedBy === null ||
          details[0].allocatedPrintedBy === "" ||
          !details[0].allocatedPrintedBy
        ) {
          PrintedBy = "";
        } else {
          PrintedBy = details[0].allocatedPrintedBy;
        }
        setfundreleasevalues({
          ...fundreleasevalues,
          Reqamt: details[0].reqAmount,
          Aprvlamt: details[0].approvalAmunt,
          FirstLvlamt: details[0].firstLevelAmount,
          secLvlamt: details[0].secondLevelAmount,
          allocatedamt: details[0].allocatedAmount,
          Release_amt: txt_amount,
          Voucher_no: details[0].allocatedVoucherNo,
          releaseRemarks: details[0].allocatedRemarks,
          Allocated_PyMd: allocatedMode,
          Voucher_type: VoucherType,
          printedType: PrintedBy,
          transactionRefInfo: details[0].referenceNo,
          BankName: details[0].bankName,
          Account_No: details[0].accountNo,
          ifscode: details[0].ifsc,
          Beneficary_Name: details[0].benName,
          gstin_No: details[0].gstinPayee,
          purpose_pmtid: payid,
          purpose_reqpurid: reqid,
          Blnc_amt: balanceAmount,
        });
      })
      .catch((error) => {
        setMessage(error.message);
        setseverit("error");
        setOpen(true);
      });
  };
  // button Operation...

  const Allocated_update_operations = () => {
    if (validationprocess() === true) {
      let details = {
        cmId: fundreleasevalues.purpose_pmtid,
        reqAmount: null,
        reqPurpose: null,
        reqPaidTo: null,
        reqDate: null,
        reqBy: null,
        approvalAmunt: null,
        approvalDate: null,
        approvalBy: null,
        firstLevelAmount: null,
        firstLevelDate: null,
        firstVeryBy: null,
        secondLevelAmount: null,
        secondLevelDate: null,
        secondVeryBy: null,
        allocatedAmount: fundreleasevalues.Release_amt,
        allocatedMode: fundreleasevalues.Allocated_PyMd,
        allocatedVoucherNo: fundreleasevalues.Voucher_no,
        allocatedVoucherType: fundreleasevalues.Voucher_type,
        allocatedVocherCopy: null,
        allocatedPrintedBy: fundreleasevalues.printedType,
        allocatedDate: null,
        allocatedBy: getUserId(),
        status: "6",
        remarks: fundreleasevalues.releaseRemarks,
        referenceNo: fundreleasevalues.transactionRefInfo,
        bankName: fundreleasevalues.BankName,
        accountNo: fundreleasevalues.Account_No,
        ifsc: fundreleasevalues.ifscode,
        benName: fundreleasevalues.Beneficary_Name,
        gstinPayee: fundreleasevalues.gstin_No,
        requestStatus: fundreleasevalues.fundstatus,
        refundStatus: null,
      };
      FundRqst_service.updatePaymentDetails(details)
        .then((res) => {
          const message = res.data.message;
          if (message.toString() === "SUCCESS") {
            setMessage("Allocated Successfully");
            setseverit("success");
            setOpen(true);
            resetalloperation();
            Getpaymentjob_nonjob_no();
          } else {
            setMessage("Allocation Failed " + message.toString());
            setseverit("error");
            setOpen(true);
          }
        })
        .catch((error) => {
          setMessage("Allocation Failed " + error.message);
          setseverit("error");
          setOpen(true);
        });
    }
  };
  const AllocatedBtn = () => {
    setallocatedProcs(true);
    Allocated_update_operations();
    setallocatedProcs(false);
  };
  const updatedBtn = () => {
    setupdateProcs(true);
    Allocated_update_operations();
    setupdateProcs(false);
  };
  const NonAllocatedBtn = () => {
    setnonallocatedProcs(true);
    let details = {
      cmId: fundreleasevalues.cmid,
      paymentId: fundreleasevalues.purpose_pmtid,
      status: "6",
      createdBy: getUserId(),
      requestStatus: fundreleasevalues.fundstatus,
    };
    FundRqst_service.updatePaymentStatus(details)
      .then((res) => {
        const message = res.data.message;
        if (message.toString() === "SUCCESS") {
          setMessage("Non Allocated Successfully");
          setseverit("success");
          setOpen(true);
          resetalloperation();
        } else {
          setMessage(
            "Non Allocation Failed ,Warning ..!!" + message.toString()
          );
          setseverit("error");
          setOpen(true);
          document.getElementById("releaseamt").focus();
        }
      })
      .catch((error) => {
        setMessage("Allocation Failed " + error.message);
        setseverit("error");
        setOpen(true);
      });
    setnonallocatedProcs(false);
  };
  const RefreshClickBtn = () => {
    setrefreshProcs(true);
    setfundreleasevalues({
      ...fundreleasevalues,
      cmid: "",
      purpose_pmtid: "",
      purpose_reqpurid: "",
      fundstatus: "JOB",
      Reqamt: "",
      Aprvlamt: "",
      FirstLvlamt: "",
      secLvlamt: "",
      allocatedamt: "",
      Release_amt: "",
      Voucher_no: "",
      Voucher_type: "",
      printedType: "",
      releaseRemarks: "",
      transactionRefInfo: "",
      BankName: "",
      Account_No: "",
      ifscode: "",
      Beneficary_Name: "",
      gstin_No: "",
      Allocated_PyMd: "",
      Blnc_amt: "",
    });
    setReleaseDetails([]);
    setReleaseDetails2([]);
    setReleaseDetails3([]);
    setReleaseDetails4([]);
    Getpaymentjob_nonjob_no();
    setALLOCATEDbtn(true);
    setUpdateBtn(true);
    setNonAlocatedBtn(true);
    setUpload_Btn(true);
    setDownload_Rcpt_Btn(true);
    setDownload_Rqst_Btn(true);
    document.getElementById("fundsts").focus();
    setrefreshProcs(false);
  };
  const ExcelValidation = () => {
    if (getUserId() === 75 || getUserId() === 118 || getUserId() === 125) {
      setbulkUploadhidden(true);
    } else {
      setbulkUploadhidden(false);
      setMessage('YOU ARE NOT A AUTHORIZED PERSON","Warning');
      setseverit("warning");
      setOpen(true);
    }
  };
  const ExcelselectFile = (event) => {
    let currentFile = event.target.files[0];
    FundRqst_service.uploadUTRTransaction(currentFile)
      .then((response) => {
        event.target.value = null;
        const message = response.data.message;
        if (message.toString() === "Insertion Success") {
          setMessage("Insertion Success");
          setseverit("success");
          setOpen(true);
        } else {
          setMessage(message.toString());
          setseverit("warning");
          setOpen(true);
        }
      })
      .catch((error) => {
        event.target.value = null;
      });
    utrDialogBoxClose();
    event.target.value = null;
  };
  const tempDownload = () => {
    if (fundreleasevalues.fundstatus !== "") {
      let details = {
        fundStatus: fundreleasevalues.fundstatus,
        consignmentNo: "-1",
      };
      FundRqst_service.writeDispatchExcel(details).then((res) => {
        if (res.data.messageCode.toString() === "0000") {
          // saveAs('http://localhost:8080/ExportFiles/' + res.data.message, res.data.message)
          saveAs(
            "http://35.154.221.117:8081/ExportFiles/" + res.data.message,
            res.data.message
          );
        }
      });
    }
    //
  };

  const saveimage = () => {
    setdwnldRcpCopyProcs(true);
    if (
      fundreleasevalues.purpose_pmtid === "" ||
      !fundreleasevalues.purpose_pmtid
    ) {
      setMessage("Please Select Audit Purpose............");
      setseverit("warning");
      setOpen(true);
      setdwnldRcpCopyProcs(false);
    } else {
      FundRqst_service.get_o_ac_payment_receipt_copy(
        fundreleasevalues.purpose_pmtid
      )
        .then((res) => {
          const data = res.data;
          const lastresult = data.map((item) => item);
          // FileSaver.saveAs(`data:image/jpeg;base64,${lastresult[0].ip_payment_receipt_copy}`, fundreleasevalues.purpose_pmtid + ".jpeg")
          const filedata = lastresult[0].toString();
          const formates = filedata.split("/9j/4");
          //    console.log('ggg '+JSON.stringify(formates))
          if (formates[0] === "") {
            FileSaver.saveAs(
              `data:image/jpg;base64,${lastresult[0].toString()}`,
              fundreleasevalues.purpose_pmtid + ".jpg"
            );
          } else {
            const Pngformates = filedata.split("iVBORw0KGg");
            if (Pngformates[0] === "") {
              FileSaver.saveAs(
                `data:image/jpg;base64,${lastresult[0].toString()}`,
                fundreleasevalues.purpose_pmtid + ".jpg"
              );
            } else {
              FileSaver.saveAs(
                `data:application/pdf;base64,${lastresult[0].toString()}`,
                fundreleasevalues.purpose_pmtid + ".pdf"
              );
            }
          }
          setdwnldRcpCopyProcs(false);
        })
        .catch((error) => {
          setMessage(error.message);
          setseverit("warning");
          setOpen(true);
          setdwnldRcpCopyProcs(false);
        });
    }
    // FileSaver.saveAs(lastresult[0].docImage, fundreleasevalues.cmid + "-" + fundreleasevalues.purpose_reqpurid + ".pdf")
    // setdwnldRcpCopyProcs(false)
  };

  const DownloadReqBtn = () => {
    setdwnldRqstCopyProcs(true);
    let details = {
      cmId: fundreleasevalues.cmid,
      reqPurpose: fundreleasevalues.purpose_reqpurid,
      status: "1",
    };
    FundRqst_service.getPaymentCopy(details)
      .then((res) => {
        const data = res.data;
        const detaill = data.map((node) => node.docImage);
        // console.log('before saveAs '+JSON.stringify(detaill.toString()))
        // FileSaver.saveAs(`data:image/jpeg;base64,${detaill.toString()}`, fundreleasevalues.cmid + "-" + fundreleasevalues.purposeOfpayment + ".jpg");
        const filedata = detaill.toString();
        const formates = filedata.split("/9j/4");
        //    console.log('ggg '+JSON.stringify(formates))
        if (formates[0] === "") {
          FileSaver.saveAs(
            `data:image/jpg;base64,${detaill.toString()}`,
            fundreleasevalues.cmid +
              "-" +
              fundreleasevalues.purposeOfpayment +
              ".jpg"
          );
        } else {
          const Pngformates = filedata.split("iVBORw0KGg");
          if (Pngformates[0] === "") {
            FileSaver.saveAs(
              `data:image/jpg;base64,${detaill.toString()}`,
              fundreleasevalues.cmid +
                "-" +
                fundreleasevalues.purposeOfpayment +
                ".jpg"
            );
          } else {
            FileSaver.saveAs(
              `data:application/pdf;base64,${detaill.toString()}`,
              fundreleasevalues.cmid +
                "-" +
                fundreleasevalues.purposeOfpayment +
                ".pdf"
            );
          }
        }
        setdwnldRqstCopyProcs(false);
      })
      .catch((error) => {
        setMessage("Insertion Failed! ," + error.message);
        setseverit("error");
        setOpen(true);
        setdwnldRqstCopyProcs(false);
      });
    // setdwnldRqstCopyProcs(false)
  };
  ////getfundstatues=======>
  const FundStatusDropdown = async () => {
    FundRqst_service.getFundStatus().then((res) => {
      setfundstatusdrp(res.data);
    });
  };
  ///
  const fundSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fundOnchange(e.target.value);
        }}
      />
    );
  };
  const fundOnchange = (searchedVal) => {
    const filteredvalue = ReleaseDetails.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails(ReleaseDetails);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const fundSrch2 = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          fund2Onchange(e.target.value);
        }}
      />
    );
  };
  const fund2Onchange = (searchedVal) => {
    const filteredvalue = ReleaseDetails4.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length > 1) {
      setFilteredDetails2(ReleaseDetails4);
    } else {
      setFilteredDetails2(filteredvalue);
    }
  };
  useEffect(() => {
    FundStatusDropdown();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const [bulkUploadhidden, setbulkUploadhidden] = useState(false);
  const [utrdialogopen, setutrdialogopen] = useState(false);
  const utrDialogBoxopen = () => {
    setutrBulkProcs(true);
    setutrdialogopen(true);
  };
  const utrDialogBoxClose = () => {
    setutrdialogopen(false);
    setutrBulkProcs(false);
  };

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate("/fundallocation");
  };
  const ForwordBotton = () => {
    navigate("/fund_rcptCpy");
  };

  const uploadrqstcopy = () => {
    setuploadRecCopyProcs(true);
    if (
      fundreleasevalues.purpose_pmtid === "" ||
      !fundreleasevalues.purpose_pmtid
    ) {
      setMessage("Please Select Request Purpose............");
      setseverit("warning");
      setOpen(true);
      setimgUpload(false);
      setuploadRecCopyProcs(false);
    } else {
      setimgUpload(true);
    }
  };
  const selectimgUpload = (event) => {
    var currentFile;
    const file = event.target.files[0];
    const imageMimeTypepng = /image\/(png)/i;
    const imageMimeTypejpg = /image\/(jpg)/i;
    const imageMimeTypeJpeg = /image\/(jpeg)/i;
    const imageMimeTypePdf = /(pdf)/i;
    const reader = new FileReader();
    reader.onload = () => {
      console.log("data " + reader.result);
      currentFile = reader.result;
      var recipetCopyFile = "";
      if (file.type.match(imageMimeTypepng)) {
        recipetCopyFile = currentFile.split("data:image/png;base64,");
      } else if (file.type.match(imageMimeTypejpg)) {
        recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
      } else if (file.type.match(imageMimeTypeJpeg)) {
        recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
      } else if (file.type.match(imageMimeTypePdf)) {
        recipetCopyFile = currentFile.split("data:pdf;base64,");
      }

      if (reader.readyState === 2) {
        // let currentFile = b64toBlob(event.target.files,{type:'base64;charset=utf-8'})
        console.log(
          "event.target.files[0] " + JSON.stringify(recipetCopyFile[1])
        );
        let details = {
          payments_id: fundreleasevalues.purpose_pmtid,
          ip_payment_receipt_copy: recipetCopyFile[1],
          user_id: getUserId(),
        };
        FundRqst_service.update_o_ac_payment_receipt_copy(details)
          .then((res) => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
              setMessage("Inserted Successfully");
              setseverit("success");
              setOpen(true);
            } else {
              setMessage("Insertion Failed! " + message.toString());
              setseverit("warning");
              setOpen(true);
            }
            event.target.files[0] = null;
            reader.readyState = 2;
            setuploadRecCopyProcs(false);
          })
          .catch((error) => {
            setMessage("Insertion Failed! ," + error.message);
            setseverit("error");
            setOpen(true);
            setuploadRecCopyProcs(false);
          });
      }
    };
    reader.readAsDataURL(event.target.files[0]);
  };
  return (
    <div>
      {/* /utr dialog box/ */}
      <Dialog open={utrdialogopen} onClose={utrDialogBoxClose}>
        <DialogTitle>UTR Bulk Upload</DialogTitle>
        <center>
          <Button
            size="small"
            variant="contained"
            className="mt-1"
            color="info"
            onClick={tempDownload}
          >
            Download Template
          </Button>{" "}
        </center>
        <label
          className="btn btn-primary p-1 mt-1 mb-1 ml-1 mr-1"
          onClick={ExcelValidation}
        >
          Upload
          {bulkUploadhidden ? (
            <input type="file" onChange={ExcelselectFile} hidden />
          ) : null}
        </label>{" "}
        {/* <center><Button size='small' variant="contained" className='mt-1' color="info">Upload UTR</Button>{' '}</center> */}
      </Dialog>

      <Home />
      <Snackbar
        open={open}
        message={message}
        severity={severit}
        onClose={handleClose}
      />
      <div
        style={{
          paddingLeft: "80px",
          transition: "1s",
          transitionDelay: "revert-layer",
        }}
      >
        <Row>
          <Col xs={1}>
            <ToggleButton
              onClick={BackBotton}
              className="headerstyleStrt"
              size="small"
            >
              <ArrowBackIosIcon
                fontSize="small"
                style={{
                  fontSize: "16px",
                  marginLeft: "5px",
                  color: "red",
                  fontWeight: "bold",
                }}
              />{" "}
            </ToggleButton>
          </Col>
          <Col xs={10}></Col>
          <Col xs={1} style={{ textAlign: "end" }}>
            {" "}
            <ToggleButton
              onClick={ForwordBotton}
              className="headerstyleEND"
              size="small"
            >
              <ArrowForwardIosIcon
                fontSize="small"
                style={{ fontSize: "16px", color: "red", fontWeight: "bold" }}
              />{" "}
            </ToggleButton>
          </Col>
        </Row>
        <Grid2 container>
          <Box style={{ width: "11.5%" }}>
            <Item1>
              {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  marginLeft: "2px",
                  fontFamily: "Times New Roman",
                }}
              >
                Non Released Job
              </lable>
              <TableContainer
                sx={{ maxHeight: 350 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.map((trns) => {
                      const isItemSelected = isSelected(trns.consignmentNumber);
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getnonpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item1>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  fontFamily: "Times New Roman",
                }}
              >
                Non Released Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 350 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ textAlign: "center", width: "100px" }}
                      >
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {ReleaseDetails2.map((trns) => {
                      const isItemSelected = isNonReqItemSelected(
                        trns.reqAmount
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.reqAmount}
                          onClick={() => nonverifypurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "37%" }}>
            <Item>
              <div
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginBottom: "1%",
                  fontFamily: "Times New Roman",
                }}
              >
                <center>FUND RELEASE</center>
              </div>
              <Csscontrol fullWidth size="small" style={{ width: "35%" }}>
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Fund Status
                </InputLabel>
                <Select
                  label="Fund Statusss"
                  id="fundsts"
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={FundReleaseStatusHandleChange}
                  value={fundreleasevalues.fundstatus}
                >
                  <MenuItem></MenuItem>
                  {fundstatusdrp.map((status) => (
                    <MenuItem value={status.requestStatus}>
                      {status.requestStatus}
                    </MenuItem>
                  ))}
                </Select>
              </Csscontrol>
              {!BeNoHidden && (
                <>
                  <CssTextField
                    size="small"
                    label="BE NO"
                    variant="outlined"
                    sx={{
                      input: {
                        fontFamily: "Times New Roman",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "13px",
                      },
                    }}
                    style={{ marginLeft: "2%", width: "35%", marginTop: "1%" }}
                    value={beNoValue}
                    onChange={(e) => setBeNoValue(e.target.value)}
                  />
                  <Button
                    size="small"
                    hidden={BeNoSearchHidden}
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: "1%", marginTop: "1%" }}
                    onClick={handleBeNoSearch}
                  >
                    {searchPros ? "Processing..." : "Search"}
                  </Button>
                </>
              )}

              <CssTextField
                hidden={JobHidden}
                size="small"
                style={{ width: "35%", marginLeft: "2%", marginRight: "1%" }}
                label="Job No"
                variant="outlined"
                sx={{
                  input: {
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: "13px",
                  },
                }}
                onChange={FundRelease_jobNoHandleChange}
                value={fundreleasevalues.jobNo}
                onKeyDown={jobkeydown}
              />

              <Button
                style={{ fontFamily: "Times New Roman" }}
                hidden={searchbtnhidden}
                size="small"
                variant="contained"
                color="primary"
                onClick={searchBtn}
              >
                Search
              </Button>

              <Csscontrol
                hidden={VendorHidden}
                fullWidth
                size="small"
                style={{ width: "35%", marginLeft: "2%" }}
              >
                <InputLabel
                  id="demo-select-small"
                  style={{ fontFamily: "Times New Roman", fontWeight: "bold" }}
                >
                  Vendor Type
                </InputLabel>
                <Select
                  InputLabelProps={{ shrink: true }}
                  label="Vendor Typeeee"
                  native
                  style={{
                    fontSize: "13px",
                    fontFamily: "Times New Roman",
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onChange={fundrelease_vendortypHandleChange}
                  value={fundreleasevalues.vendorType}
                >
                  <option></option>
                  {Vendordrp.map((trns) => (
                    <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                  ))}
                </Select>
              </Csscontrol>

              <div hidden={designHidden}>
                <Row className="mt-3">
                  <Col>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      Request Amt :
                    </InputLabel>
                  </Col>
                  <Col
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {fundreleasevalues.Reqamt}
                  </Col>
                  <Col>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      Approval Amt :
                    </InputLabel>
                  </Col>
                  <Col
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {fundreleasevalues.Aprvlamt}
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      1stLvlVerifAmt :
                    </InputLabel>
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {fundreleasevalues.FirstLvlamt}
                  </Col>
                  <Col xs={3}>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      2ndLvlVerifAmt :
                    </InputLabel>
                  </Col>
                  <Col
                    xs={3}
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {fundreleasevalues.secLvlamt}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputLabel
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "Times New Roman",
                      }}
                    >
                      Allocated Amt :
                    </InputLabel>
                  </Col>
                  <Col
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "Red",
                      fontFamily: "Times New Roman",
                    }}
                  >
                    {fundreleasevalues.allocatedamt}
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row>
                  <center>
                    <CssTextField
                      size="small"
                      style={{
                        width: "35%",
                        marginLeft: "2%",
                        marginRight: "1%",
                        marginTop: "1%",
                      }}
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "darkorange",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={FundRelease_blncAmtHandleChange}
                      value={fundreleasevalues.Blnc_amt}
                    />
                  </center>
                </Row>

                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      size="small"
                      id="releaseamt"
                      label="Release Amount"
                      variant="outlined"
                      style={{ width: "49%" }}
                      required
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_alocatedamtHandleChange}
                      value={fundreleasevalues.Release_amt}
                      onKeyDown={releaseAmtKeydown}
                    />

                    <Csscontrol
                      fullWidth
                      size="small"
                      style={{ width: "49%", marginLeft: "1%" }}
                      required
                      onKeyDown={paymentMdKeydown}
                    >
                      <InputLabel
                        id="demo-select-small"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Mode
                      </InputLabel>
                      <Select
                        label="Payment Mode"
                        id="payid"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                        InputLabelProps={{ shrink: true }}
                        native
                        onChange={fundrelease_Allocated_PyMdHandleChange}
                        value={fundreleasevalues.Allocated_PyMd}
                      >
                        <option></option>
                        {PaymentModedrp.map((trns) => (
                          <option value={trns.paymentType}>
                            {trns.paymentType}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      size="small"
                      id="voucherNo"
                      label="Voucher No"
                      variant="outlined"
                      style={{ width: "49%" }}
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_Voucher_noHandleChange}
                      value={fundreleasevalues.Voucher_no}
                      onKeyDown={voucherNoKeydown}
                    />

                    <Csscontrol
                      fullWidth
                      size="small"
                      style={{ width: "49%", marginLeft: "1%" }}
                      onKeyDown={vouchertypeKeydown}
                      required
                    >
                      <InputLabel
                        id="demo-select-small"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "bold",
                        }}
                      >
                        Voucher Type
                      </InputLabel>
                      <Select
                        label="Voucher Type"
                        id="Vchrid"
                        InputLabelProps={{ shrink: true }}
                        native
                        style={{
                          fontSize: "13px",
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                        onChange={fundrelease_Voucher_typeHandleChange}
                        value={fundreleasevalues.Voucher_type}
                      >
                        <option> </option>
                        {voucherdrp.map((trns) => (
                          <option value={trns.voucherType}>
                            {trns.voucherType}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <Csscontrol
                      fullWidth
                      size="small"
                      style={{ width: "49%" }}
                      onKeyDown={printedKeydown}
                      required
                    >
                      <InputLabel
                        id="demo-select-small"
                        style={{
                          fontFamily: "Times New Roman",
                          fontWeight: "bold",
                        }}
                      >
                        Printed Type
                      </InputLabel>
                      <Select
                        label="Payment Mode"
                        id="printid"
                        native
                        style={{
                          fontSize: "13px",
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                        onChange={fundrelease_printedTypeHandleChange}
                        value={fundreleasevalues.printedType}
                      >
                        <option></option>
                        {printeddrp.map((trns) => (
                          <option value={trns.printedType}>
                            {trns.printedType}
                          </option>
                        ))}
                      </Select>
                    </Csscontrol>

                    <CssTextField
                      size="small"
                      label="Release Remarks"
                      id="releaseRmks"
                      variant="outlined"
                      style={{ width: "49%", marginLeft: "1%" }}
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_releaseRemarksHandleChange}
                      value={fundreleasevalues.releaseRemarks}
                      onKeyDown={releaseRmkskeydown}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      size="small"
                      style={{ width: "49%" }}
                      id="TrnsRefNo"
                      label="Transaction Ref No"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_transactionRefInfoHandleChange}
                      value={fundreleasevalues.transactionRefInfo}
                      onKeyDown={TrnsRefNoKeydown}
                    />
                    <CssTextField
                      size="small"
                      style={{ width: "49%", marginLeft: "1%" }}
                      id="banknameid"
                      label="Bank Name"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_BankNameHandleChange}
                      value={fundreleasevalues.BankName}
                      onKeyDown={bankNameKeydown}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      size="small"
                      style={{ width: "49%" }}
                      id="AcntNo"
                      label="Account No"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_Account_NoHandleChange}
                      value={fundreleasevalues.Account_No}
                      onKeyDown={AcntNoKeydown}
                    />
                    <CssTextField
                      size="small"
                      style={{ width: "49%", marginLeft: "1%" }}
                      id="ifscodeId"
                      label="IFSC Code"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_ifscodeHandleChange}
                      value={fundreleasevalues.ifscode}
                      onKeyDown={ifscodeKeydown}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <CssTextField
                      size="small"
                      style={{ width: "49%" }}
                      label="Beneficiary Name"
                      id="beneficaryId"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_Beneficary_NameHandleChange}
                      value={fundreleasevalues.Beneficary_Name}
                      onKeyDown={beneficaryNameKeydown}
                    />
                    <CssTextField
                      size="small"
                      style={{ width: "49%", marginLeft: "1%" }}
                      id="gstinId"
                      label="GSTIN No"
                      variant="outlined"
                      sx={{
                        input: {
                          fontFamily: "Times New Roman",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "13px",
                        },
                      }}
                      onChange={fundrelease_gstin_NoHandleChange}
                      value={fundreleasevalues.gstin_No}
                    />
                  </Col>
                </Row>
              </div>
            </Item>
          </Box>
          <Box style={{ width: "20%" }}>
            <Item>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  fontFamily: "Times New Roman",
                }}
              >
                Released Purpose
              </lable>
              <TableContainer
                sx={{ maxHeight: 350 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{ width: "10px", textAlign: "center" }}
                      >
                        Sl
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ width: "40px", textAlign: "center" }}
                      >
                        Amount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {ReleaseDetails3.map((trns) => {
                      const isItemSelected = isReqItemSelected(trns.reqAmount);
                      return (
                        <TableRow
                          selected={isItemSelected}
                          hover
                          key={trns.reqPurpose}
                          onClick={() => verifypurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.serialNumber}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqPurpose}
                          </StyledTableCell>
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.reqAmount}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item>
          </Box>
          <Box style={{ width: "11.5%" }}>
            <Item2>
              <lable
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  color: "red",
                  marginRight: "10px",
                  fontFamily: "Times New Roman",
                }}
              >
                Released Job
              </lable>
              {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
              <TableContainer
                sx={{ maxHeight: 350 }}
                className="scrollbarPrime"
              >
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        `{FundStsName()}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {fundSrch2()}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails2.map((trns) => {
                      const isItemSelected = isReqjobSelected(
                        trns.consignmentNumber
                      );
                      return (
                        <TableRow
                          hover
                          selected={isItemSelected}
                          key={trns.consignmentNumber}
                          onClick={() => getpurpose(trns)}
                        >
                          <StyledTableCell
                            style={{ textAlign: "center", color: "darkblue" }}
                          >
                            {trns.consignmentNumber}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Item2>
          </Box>
        </Grid2>
        <center hidden={designHidden}>
          <div className="mt-2 mb-1 form-inline">
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              color="primary"
              className="mt-1"
              disabled={ALLOCATEDbtn}
              onClick={AllocatedBtn}
            >
              {allocatedProcs ? "processing..." : "RELEASE"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={UpdateBtn}
              onClick={updatedBtn}
            >
              {updateProcs ? "processing..." : "UPDATE"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={NonAlocatedBtn}
              onClick={NonAllocatedBtn}
            >
              {nonallocatedProcs ? "processing..." : "NON RELEASE"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              onClick={RefreshClickBtn}
            >
              {refreshProcs ? "processing..." : "REFRESH"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              onClick={utrDialogBoxopen}
            >
              {utrBulkProcs ? "processing..." : "UTR BULK UPLOAD"}
            </Button>{" "}
            {/* <Button size='small' variant="contained" className='mt-1' color="primary" disabled={Upload_Btn}>{uploadRecCopyProcs ? 'processing...' : 'Upload Receipt copy'}</Button>{' '} */}
            <label
              style={{ fontFamily: "Times New Roman" }}
              onClick={uploadrqstcopy}
              className="btn btn-primary p-1 mt-1"
              disabled={Upload_Btn}
            >
              {uploadRecCopyProcs ? "processing..." : "UPLOAD REQUEST COPY"}
              {imgUpload ? (
                <input type="file" onChange={selectimgUpload} hidden />
              ) : null}
            </label>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={Download_Rcpt_Btn}
              onClick={saveimage}
            >
              {dwnldRcpCopyProcs ? "processing..." : "DOWNLOAD RECEPIT COPY"}
            </Button>{" "}
            <Button
              style={{ fontFamily: "Times New Roman" }}
              size="small"
              variant="contained"
              className="mt-1"
              color="primary"
              disabled={Download_Rqst_Btn}
              onClick={DownloadReqBtn}
            >
              {dwnldRqstCopyProcs ? "processing..." : "DOWNLOAD REQUEST COPY"}
            </Button>{" "}
          </div>
        </center>
        <Item hidden={tablehidden}>
          <TableContainer sx={{ maxHeight: 215 }} className="scrollbarPrime">
            <Table stickyHeader className="table table-bordered">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Sl
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Description
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Request_Date
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    RequestBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ApprovalBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    1stApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2ndLevelRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    2nd_ApprovedBy
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AllocatedBY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    ReleaseRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Release_BY
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedAmmount
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedDate
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedRemarks
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    AuditedBY
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {ReleaseDetails5.map((trns) => (
                  <TableRow hover key={trns.reqPurpose}>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.serialNumber}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqPurpose}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.reqByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalAmunt}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.appRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.approvalByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.firstLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.secondLevelVeryBy}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedDate}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.allocatedByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseAmount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.release_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseRemarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.releaseByName}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_amount}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_date}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audit_remarks}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: "center" }}>
                      {trns.audited_by}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Item>
      </div>
    </div>
  );
}
export default FundRelease;
